import appLink from './link.vue';
export default {
  name: 'menuItem',
  components: {
    appLink
  },
  inject: {
    components: {
      default: {
        appLink
      }
    }
  },
  props: {
    currentRoute: {
      type: Object,
      required: true
    }
  }
};